import { DoqFaceSvgProps } from '../types';

const ComponentTreeError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <defs>
      <clipPath id="clip0_2663_52522">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_2663_52522)">
      <mask
        id="mask0_2663_52522"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#BB58BC" />
      </mask>
      <g mask="url(#mask0_2663_52522)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
        <circle cx="160" cy="160" r="160" fill="#A3CBF5" />
        <rect x="80" y="120" width="160" height="200" fill="white" />
        <path
          d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
          fill="#1D9071"
        />
        <path
          d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
          fill="#1D9071"
        />
        <path
          d="M152.129 120V100.371C147.919 101.606 143.496 102.117 139.136 101.84C130.588 101.287 122.489 97.9655 116.036 92.3664C109.689 86.895 105.308 79.2095 103.727 71.0131C103.727 70.9705 103.705 70.9279 103.705 70.8854C103.256 68.3945 103 65.8824 103 63.3489C103 61.8374 104.026 60.7729 105.351 60.262C110.757 58.1969 116.719 57.324 122.489 57.8776C131.636 58.7717 140.312 62.7954 146.701 69.3951C150.997 73.8446 154.095 79.2308 155.848 85.0641C156.553 80.2953 158.006 75.6542 160.143 71.2899C164.866 61.7096 173.179 53.8964 183.03 49.7237C194.014 45.0613 206.473 44.7207 217.649 49.0212C218.996 49.5321 220 50.5753 220 52.1081C220 55.1099 219.701 58.1117 219.167 61.0497C219.167 61.0922 219.145 61.1348 219.145 61.1987C218.077 66.7765 215.94 72.2053 212.862 76.9954C207.37 85.5538 199.143 92.0257 189.569 95.4959C180.359 98.8383 170.059 98.9874 160.699 96.1346V120H152.129Z"
          fill="#548982"
        />
        <path
          d="M72 128C72 123.582 75.5817 120 80 120H240C244.418 120 248 123.582 248 128V152C248 156.418 244.418 160 240 160H80C75.5817 160 72 156.418 72 152V128Z"
          fill="#D6910E"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.141 248C102.141 246.895 103.036 246 104.141 246H205.141C206.245 246 207.141 246.895 207.141 248V254C207.141 255.105 206.245 256 205.141 256H104.141C103.036 256 102.141 255.105 102.141 254V248ZM106.548 249.193L109.135 251.78L111.721 249.193C111.981 248.933 112.401 248.933 112.661 249.193C112.921 249.453 112.921 249.873 112.661 250.133L109.601 253.193C109.341 253.453 108.921 253.453 108.661 253.193L105.601 250.133C105.341 249.873 105.341 249.453 105.601 249.193C105.861 248.94 106.288 248.933 106.548 249.193Z"
        fill="#1D9071"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.141 272C103.141 270.895 104.036 270 105.141 270H206.141C207.245 270 208.141 270.895 208.141 272V278C208.141 279.105 207.245 280 206.141 280H105.141C104.036 280 103.141 279.105 103.141 278V272ZM107.556 273.194L110.142 275.78L112.729 273.194C112.989 272.934 113.409 272.934 113.669 273.194C113.929 273.454 113.929 273.874 113.669 274.134L110.609 277.194C110.349 277.454 109.929 277.454 109.669 277.194L106.609 274.134C106.349 273.874 106.349 273.454 106.609 273.194C106.869 272.94 107.296 272.934 107.556 273.194Z"
        fill="#1D9071"
        fillOpacity="0.5"
      />
      <path
        d="M111.141 282C110.036 282 109.141 282.895 109.141 284V290C109.141 291.105 110.036 292 111.141 292H212.141C213.245 292 214.141 291.105 214.141 290V284C214.141 282.895 213.245 282 212.141 282H111.141Z"
        fill="#1D9071"
        fillOpacity="0.5"
      />
      <path
        d="M112.859 260C112.859 258.895 113.755 258 114.859 258H215.859C216.964 258 217.859 258.895 217.859 260V266C217.859 267.105 216.964 268 215.859 268H114.859C113.755 268 112.859 267.105 112.859 266V260Z"
        fill="#1D9071"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.851 200.005C159.816 200.082 159 200.946 159 202C159 203.105 159.895 204 161 204H175.5C177.433 204 179 205.567 179 207.5C179 207.67 178.988 207.837 178.964 208.001L179 208.001C179.001 209.105 179.896 210 181 210C182.105 210 183 209.105 183 208C183 207.942 182.997 207.884 182.993 207.826L182.984 208.001C182.994 207.835 183 207.668 183 207.5C183 203.358 179.642 200 175.5 200H161L160.851 200.005Z"
        fill="#3AA186"
      />
    </g>
  </svg>
);

export { ComponentTreeError };
